module.exports = __webpack_public_path__ + "static/media/mfprisma.8c33ce0d.png";